import * as React from "react";
function SvgArrowRight(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth={2}
        d="M4 16h22m-8-9l9 9-9 9"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgArrowRight);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
